import React from "react"
import styles from "./styles.scss"
import YAxis from "./YAxis"
import XAxis from "./XAxis"
import XAxisLine from "./XAxisLine"
import Waypoint from "react-waypoint"
import DiagonalLine from "./DiagonalLine"
import Text from "./Text"
import Reveal from "components/Reveal"
import MobileChart from "../MobileChart"
import { detect } from "detect-browser"

const browser = detect()

const STEPS = [
  {
    id: 1,
    title: "Behovsanalys & förstudie",
    icon: ["far", "file-alt"],
    text: `För att säkerställa att ni är i behov av våra tjänster och vår kunskap
    så utför vi en behovsanalys och förstudie som sedan leder till underlag för en
    potentiell kravspecifikation.`,
  },
  {
    id: 2,
    title: "Kravspecifikation & offert",
    icon: ["far", "handshake"],
    text: `Vi skapar en kravspecifikation och en offert som ni ser över i lugn och ro.
    Syftet är att ni ska kunna känna er trygga med vad ni beställer och vad det kommer
    att kosta.`,
  },
  {
    id: 3,
    title: "Interaktions- och UI-design",
    icon: ["far", "object-ungroup"],
    text: `När ni godkänt kravspecifikationen och offerten hittar vi en tid för ett möte
    via Skype eller det som passar er bäst. Gemensamt kommer vi fram till en design som
    fyller era krav och som ger önskat resultat.`,
  },
  {
    id: 4,
    title: "Utveckling",
    icon: ["far", "code"],
    text: `Er produkt utvecklas alltid med välskriven och strukturerad kod, vilket
    underlättar vid vidareutveckling och underhåll. Vi levererar snabba och smidiga
    lösningar som bygger på den senaste tekniken.`,
  },
  {
    id: 5,
    title: "Färdig produkt",
    icon: ["fas", "check"],
    text: `När den färdiga produkten levererats har ni ökat värdet i ert företag,
    precis som grafen visar. Vi fixar även hosting, potentiell vidareutveckling samt
    dokumentation.`,
  },
]

class Chart extends React.Component {
  chart = React.createRef()
  state = {
    hypotenuse: undefined,
    angle: undefined,
    chartRevealed: false,
    activeStepId: 1,
    activeStep: STEPS[0],
  }

  componentDidMount() {
    window.addEventListener("resize", this.onResize)
    this.onResize()
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize)
  }

  setActiveStep = id => {
    const activeStep = STEPS.find(x => x.id === id)
    this.setState({ activeStepId: id, activeStep })
  }

  onResize = () => {
    if (!this.chart.current) return

    const width = this.chart.current.clientWidth
    const height = this.chart.current.clientHeight

    const hypotenuse = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2))
    const angle = Math.atan(height / width) * (180 / Math.PI)

    this.setState({ hypotenuse, angle })
  }

  revealChart = () => this.setState({ chartRevealed: true })

  render() {
    const {
      hypotenuse,
      angle,
      chartRevealed,
      activeStepId,
      activeStep,
    } = this.state
    const iconWidth = 60

    const isIE = browser.name === "ie"

    return (
      <section className={styles.container}>
        <div className={styles.wrapper}>
          <h2 className={styles.title}>
            Vår <span>värdeskapande</span> process
          </h2>
          {!isIE && (
            <div className={styles.innerWrapper}>
              <span className={styles.yAxisTitle}>VÄRDE</span>
              <div className={styles.outerChartContainer}>
                <YAxis steps={STEPS} iconWidth={iconWidth} />
                <div ref={this.chart} className={styles.innerChartContainer}>
                  <Reveal className={styles.description}>
                    <span>
                      Vi hjälper er från tanke till färdig produkt genom vår
                      enkla och tydliga process med fokus på värdeskapande.
                    </span>
                  </Reveal>
                  <Waypoint onEnter={this.revealChart} />
                  <DiagonalLine
                    steps={STEPS}
                    angle={angle}
                    activeStepId={activeStepId}
                    iconWidth={iconWidth}
                    hypotenuse={hypotenuse}
                    chartRevealed={chartRevealed}
                    onHover={this.setActiveStep}
                  />
                  <div className={styles.xAxisLines}>
                    <span />
                    {STEPS.map(step => (
                      <XAxisLine key={step.icon} iconWidth={iconWidth} />
                    ))}
                    <span />
                  </div>
                  <Text activeStep={activeStep} chartRevealed={chartRevealed} />
                </div>
                <XAxis steps={STEPS} iconWidth={iconWidth} />
                <span className={styles.xAxisTitle}>PROCESS-STEG</span>
              </div>
            </div>
          )}
          <MobileChart processSteps={STEPS} isIE={isIE} />
        </div>
      </section>
    )
  }
}

export default Chart



// WEBPACK FOOTER //
// ./src/pages/LandingPage/Chart/index.jsx